<template>
  <div class="d-flex flex-column position-relative">
    <div class="d-flex justify-content-between" style="gap: 1.5rem">
      <div class="table-wrapper" style="width: 60%">
        <table class="w-100">
          <thead>
            <tr>
              <th
                v-for="headerItem in header"
                :key="headerItem.key"
                :style="headerItem.style"
              >
                {{ headerItem.name }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="rowItem in data"
              :key="rowItem.id"
              :style="
                rowItem?.id == selectedCampaign?.id
                  ? 'background-color:#fff5f5;'
                  : ''
              "
            >
              <td
                v-for="headerRowItem in header"
                :key="headerRowItem.key"
                @click="
                  handleCampaignColClick({
                    key: headerRowItem.key,
                    item: rowItem,
                  })
                "
                :style="headerRowItem.key == 'action' ? 'cursor: pointer;' : ''"
              >
                <!-- ACTION -->
                <div
                  v-if="headerRowItem.key == 'action'"
                  class="text-center action"
                >
                  <font-awesome-icon
                    v-if="selectedCampaign?.id == rowItem.id"
                    icon="fa-solid fa-chevron-left"
                    color="#8D94A6"
                  />
                  <font-awesome-icon
                    v-else
                    icon="fa-solid fa-chevron-right"
                    color="#8D94A6"
                  />
                </div>
                <!-- STATUS -->
                <div class="fw-bold" v-if="headerRowItem.key == 'status'">
                  <span
                    class="text-capitalize"
                    :class="statusClassGenerator(rowItem[headerRowItem.key])"
                    v-if="rowItem[headerRowItem.key]"
                  >
                    {{ rowItem[headerRowItem.key] }}
                  </span>
                </div>
                <!-- OTHERS -->
                <div v-else>
                  <span>
                    {{ rowItem[headerRowItem.key] }}
                  </span>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div
        v-if="voucherLoading"
        class="d-flex justify-content-center mt-5"
        style="height: fit-content; width: 40%; max-height: 500px"
      >
        <div
          class="spinner-border text-danger"
          role="status"
          style="width: 3rem; height: 3rem; border-width: 0.5rem"
        >
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
      <div
        v-show="vouchers && !voucherLoading"
        class="table-wrapper"
        style="height: fit-content; width: 40%; max-height: 500px"
        ref="voucherRef"
      >
        <table class="w-100">
          <thead class="sticky-row">
            <tr>
              <th
                v-for="headerItem in headerVouchers"
                :key="headerItem.key"
                :style="headerItem.style"
              >
                {{ headerItem.name }}
              </th>
            </tr>
          </thead>
          <tbody>
            <template v-if="vouchers?.length">
              <tr v-for="rowItem in vouchers" :key="rowItem.id">
                <td
                  class="voucher"
                  v-for="headerRowItem in headerVouchers"
                  :key="headerRowItem.key"
                >
                  <!-- ACTION -->
                  <div v-if="headerRowItem.key == 'action'" class="action">
                    <button
                      class="btn fw-bold text-danger border-danger"
                      @click="handleActionVoucher(rowItem)"
                    >
                      Reserve Voucher
                    </button>
                  </div>
                  <div
                    class="d-flex align-items-center"
                    v-if="headerRowItem.key == 'usage'"
                  >
                    <span> {{ rowItem.usage }} / </span>
                    <span v-if="rowItem.limitUsage">{{
                      rowItem.limitUsage
                    }}</span>
                    <span v-else class="fsize-18" style="line-height: 20px"
                      >∞</span
                    >
                  </div>
                  <!-- OTHERS -->
                  <div v-else>
                    <span>
                      {{ rowItem[headerRowItem.key] }}
                    </span>
                  </div>
                </td>
              </tr>
            </template>
            <tr v-else>
              <td class="text-secondary fw-bold text-center" colspan="3">
                There are no voucher in this campaign
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="pagination-container">
      <Pagination :size="perPage" :total="totalRows" @onChange="onPageChange" />
    </div>
    <TemplateModal :show="showModal" :preventOuterClick="true" :center="true">
      <div class="modal-content">
        <div class="modal-header">
          <p class="fw-bold modal-title">Reserve Voucher</p>
        </div>
        <div class="modal-body mx-3">
          <div class="row">
            <label class="col-lg-12 col-form-label text-start">
              Voucher Name
            </label>
            <label
              class="col-lg-12 col-form-label text-start text-uppercase"
              style="color: #5e50a1"
            >
              <input
                type="text"
                v-model="selectedVoucher.name"
                class="form-control"
                disabled
                readonly
              />
            </label>
          </div>
          <div class="d-flex flex-column">
            <div class="row">
              <label class="col-lg-12 col-form-label text-start">
                Member Codes (Separate by Enter)
              </label>
              <div class="d-flex flex-column col-md-12">
                <textarea
                  type="text"
                  v-model="memberCodes"
                  class="form-control"
                  placeholder="Member Codes"
                />
                <span
                  class="align-self-end mt-2"
                  :class="{ 'text-danger': isLimitExceeded }"
                >
                  {{ numberOfLine }} / {{ limitCodes }}
                </span>
              </div>
            </div>
            <span v-if="errors.reserve" class="text-danger">{{
              errors.reserve
            }}</span>
          </div>
          <div class="flex mt-5">
            <div class="d-flex ms-auto" style="gap: 1rem; width: 60%">
              <button
                type="button"
                class="btn btn-lg fw-bold text-danger border-danger flex-fill"
                @click="showModal = false"
              >
                CLOSE
              </button>

              <button
                type="button"
                class="btn btn-lg btn-danger fw-bold text-white flex-fill"
                @click="showModalConfirm = true"
                :disabled="disableButton"
              >
                SAVE & RUN
              </button>
            </div>
          </div>
        </div>
      </div>
    </TemplateModal>
    <TemplateModal
      :show="showModalConfirm"
      @handleClose="showModalConfirm = false"
      :center="true"
    >
      <div class="modal-content">
        <div class="modal-header">
          <p class="fw-bold modal-title fsize-16">Alert</p>
        </div>
        <div class="modal-body">
          <div class="row mb-3">
            <label class="col-lg-12 col-form-label fw-bold text-start">
              Are you sure want to run the {{ selectedVoucher.name }} reserve?
            </label>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-secondary bg-white text-body fw-bold me-3 border border-0 text-uppercase"
            @click="showModalConfirm = false"
          >
            Cancel
          </button>
          <button
            type="button"
            class="btn btn-secondary bg-white fw-bold text-danger border border-0 text-uppercase"
            @click="handleSubmit"
          >
            Confirm
          </button>
        </div>
      </div>
    </TemplateModal>
  </div>
</template>

<script>
import Pagination from "@/components/Pagination.vue";
import TemplateModal from "@/components/TemplateModal.vue";
export default {
  components: {
    Pagination,
    TemplateModal,
  },
  data() {
    return {
      errors: {},
      showModal: false,
      showModalConfirm: false,
      perPage: 10,
      currentPage: 1,
      // assume data count 50
      totalRows: 1,
      memberCodes: "",
      limitCodes: 1000,
      header: [
        {
          name: "APPLICATION",
          key: "application",
        },
        {
          name: "CAMPAIGN NAME",
          key: "name",
        },
        {
          name: "ID",
          key: "id",
        },
        {
          name: "STATUS",
          key: "status",
        },
        {
          name: "ACTION",
          key: "action",
        },
      ],
      selectedCampaign: null,
      data: [],
      headerVouchers: [
        {
          name: "VOUCHER NAME",
          key: "name",
          style: "width:30%;",
        },
        {
          name: "USAGE",
          key: "usage",
          style: "width:40%;",
        },
        {
          name: "ACTION",
          key: "action",
        },
      ],
      vouchers: null,
      selectedVoucher: {},
      voucherPage: 1,
      voucherSize: 25,
      voucherCount: 0,
      voucherLoading: false,
    };
  },
  computed: {
    memberCodesArr() {
      return this.memberCodes.split(/\r|\r\n|\n/).filter((x) => x);
    },
    numberOfLine() {
      return this.memberCodesArr.length;
    },
    isLimitExceeded() {
      return this.numberOfLine > this.limitCodes;
    },
    disableButton() {
      return this.isLimitExceeded || !this.memberCodesArr.length;
    },
  },
  mounted() {
    this.getData();
    this.$refs.voucherRef &&
      this.$refs.voucherRef.addEventListener("scroll", this.handleScroll);
  },
  unmounted() {
    this.$refs.voucherRef &&
      this.$refs.voucherRef.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll() {
      const el = this.$refs.voucherRef;
      let calc =
        (el && Math.floor(el.scrollHeight - el.scrollTop - el.clientHeight)) ||
        0;

      if (el && calc <= 10 && !this.voucherLoading) {
        if (
          this.vouchers.length % this.voucherSize === 0 &&
          this.voucherCount !== 0
        ) {
          console.log("HIT BOTTOM SCROLL");
          this.voucherPage++;
          this.getVouchers();
        }
      }
    },
    statusClassGenerator(status) {
      if (status == "disabled" || status == "expired") {
        return "text-danger";
      }
      if (status == "enabled" || status == "scheduled" || status == "running") {
        return "text-success";
      }
      return "text-secondary";
    },
    getData() {
      const payload = {
        size: this.perPage,
        page: this.currentPage,
      };
      this.$store
        .dispatch("voucher/getAllCampaign", payload)
        .then(({ data }) => {
          const campaigns = data.data.items;
          const parsedTable = campaigns.map((campaign) => {
            return {
              id: campaign.id,
              application: campaign.applicationName,
              name: campaign.name,
              status: campaign.state,
            };
          });
          this.data = parsedTable;
          this.totalRows = data.data.count;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getVouchers() {
      const payload = {
        page: this.voucherPage,
        size: this.voucherSize,
      };
      this.voucherLoading = true;
      this.$store
        .dispatch("voucher/getAllVoucherByCampaign", {
          id: this.selectedCampaign.id,
          payload,
        })
        .then(({ data }) => {
          const vouchers = data?.data?.items || [];
          const parsedTable = vouchers.map((voucher) => {
            return {
              name: voucher.voucherCode,
              limitUsage: voucher.usageCounterMax,
              usage: voucher.usageCounter,
              voucherCode: voucher.voucherCode,
            };
          });
          if (this.voucherPage > 1) {
            this.vouchers = [...this.vouchers, ...parsedTable];
          } else {
            this.vouchers = parsedTable;
          }
          this.voucherCount = data?.data?.count;
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.voucherLoading = false;
        });
    },
    handleCampaignColClick({ key, item }) {
      if (key == "action") {
        this.handleAction(item);
      }
    },
    handleAction(item) {
      if (this.selectedCampaign?.id == item.id) {
        this.selectedCampaign = null;
        this.vouchers = null;
      } else {
        this.selectedCampaign = item;
        this.vouchers = null;
        this.voucherPage = 1;
        this.getVouchers();
      }
    },
    handleActionVoucher(item) {
      this.errors = {};
      this.showModal = true;
      this.memberCodes = "";
      this.selectedVoucher = item;
    },
    handleSubmit() {
      this.errors = {};
      this.$store
        .dispatch("voucher/postVoucherRegisterMember", {
          code: this.selectedVoucher.voucherCode,
          payload: {
            member_codes: this.memberCodesArr,
          },
        })
        .then((res) => {
          this.showModalConfirm = false;
          this.showModal = false;
          this.$swal({
            icon: "success",
            title: "Success Reserve Voucher",
            showConfirmButton: false,
            timer: 1500,
          });
        })
        .catch((error) => {
          const errMsg = error.response?.data?.errorMessage;
          this.errors = { reserve: errMsg };
          this.showModalConfirm = false;
        });
    },
    onPageChange({ page, size }) {
      this.selectedCampaign = null;
      this.currentPage = page;
      this.perPage = size;
      // console.log({ page, size });
      this.vouchers = null;
      this.getData();
    },
  },
};
</script>

<style lang="scss" scoped>
.table-wrapper {
  border: thin solid #e3e3e3;
  border-radius: 5px;
  overflow: auto;
}
tr {
  border-bottom: thin solid #e3e3e3;
  &:last-child {
    border-bottom-width: 0;
  }
}
th {
  background-color: #f3f2f8;
  color: #8d94a6;
  font-weight: bold;
  font-size: 10px;
  padding: 1rem;
}
td {
  padding: 1rem;
  &.voucher {
    padding: 0.55rem 1rem;
  }
}
.pagination-container {
  position: absolute;
  margin: 0 -1.5rem;
  bottom: -75px;
  right: 0;
  left: 0;
}

.action {
  -webkit-user-select: none; /* Safari */
  -ms-user-select: none; /* IE 10 and IE 11 */
  user-select: none; /* Standard syntax */
}

.sticky-row {
  position: sticky;
  top: 0;
}

textarea {
  resize: none;
  &.form-control {
    min-height: 200px;
  }
}
</style>
